import {
  COMPANY_MAX_NAME_LENGTH,
  COMPANY_MAX_NAME_ON_RECEIPT_LENGTH,
  COMPANY_MAX_ADDRESS_DETAIL_LENGTH,
  COMPANY_MAX_URL_LENGTH,
  COMPANY_MAX_BUSINESS_DESCRIPTION_LENGTH,
} from '../../../lib/constants.js.erb';

$(() => {
  $('.js-validate-form-company').validate({
    rules: {
      'company[name]': {
        required: true,
        maxlength: COMPANY_MAX_NAME_LENGTH,
      },
      'company[name_on_receipt]': {
        maxlength: COMPANY_MAX_NAME_ON_RECEIPT_LENGTH,
      },
      'company[address_detail]': {
        maxlength: COMPANY_MAX_ADDRESS_DETAIL_LENGTH,
      },
      'company[url]': {
        maxlength: COMPANY_MAX_URL_LENGTH,
      },
      'company[business_description]': {
        maxlength: COMPANY_MAX_BUSINESS_DESCRIPTION_LENGTH,
      },
    },
  });
});
